import React, { useEffect, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import Header from "common/js/header/header";
import Loader from "common/components/Loader";
import BackupTable from "./backupTbl";
import BackupSlider from "./backupSlider";



const BackupCtrl = () => {
    const [loader, setLoader] = useState("none");
    const [opacity, setOpacity] = useState(1);
    const [lstBackup, setLstBackup] = useState([
        {
            backupId: 1,
            backup: "Backup_2024_06_24",
            backupNotes: "Daily backup",
            generationDt: "2024-06-24 02:00"
        },
        {
            backupId: 2,
            backup: "Backup_2024_06_23",
            backupNotes: "Manual backup before update",
            generationDt: "2024-06-23 18:30"
        }
    ]);
    const [backupId, setBackupId] = useState(0);
    const [backupObj, setBackupObj] = useState({});
    const [flgShowSlider, setFlgShowSlider] = useState(false);
    const [backupKey, setBackupKey] = useState(0);

    useEffect(() => {
        // getBackupList();
    }, [backupKey]);

    const getBackupList = () => {
        setLoader("block");
        setOpacity(0.5);
        // getBackupListSvc(backupListResponse);
    };

    const backupListResponse = (data) => {
        if (data.status === "Success") {
            setLstBackup(data.lstBackup);
        } else if (data.status === "Failure") {
            handleServiceError(data.message);
        } else {
            toast.error("Service failed " + data.error);
        }
        setLoader("none");
        setOpacity(1);
    };

    const handleServiceError = (svcMsg) => {
        toast.error(svcMsg);
    };

    const restoreBackup = (backupId) => {
        // Add your restore logic here
        toast.info("Restoring backup with ID", backupId);
    };

    const backupTimetable = async () => {
        // Add your backup logic here
        await setBackupId(0);
        await setBackupObj({});
        setFlgShowSlider(true);
    };

    const openSlider = async (backupObj) => {
        await setBackupId(backupObj.backupId);
        await setBackupObj(backupObj);
        setFlgShowSlider(true);
    };

    const updateKey = () => {
        setBackupKey(prevKey => prevKey + 1);
    };

    const closeSlider = () => {
        setFlgShowSlider(false);
        setBackupId(0);
        setBackupObj({});
    }

    return (
        <div>
            <Header />
            <ToastContainer autoClose={3000} hideProgressBar />
            <Loader loader={loader} position="fixed" />
            <div
                className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{
                    cursor: loader === "none" ? "pointer" : "none",
                    pointerEvents: loader === "none" ? "auto" : "none",
                    opacity: opacity

                }}
            >
                <div className="col-lg-10 col-md-10 col-sm-10 col-xs-10 col-centered padding-remove" style={{ marginTop: "30px" }}>
                    <div className="col-md-12 col-xs-12 col-centered padding-remove" style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
                        <button
                            className="btn btn-info"
                            onClick={backupTimetable}
                        >
                            Backup Timetable
                        </button>
                    </div>
                    <div className="col-md-12 col-xs-12 col-centered padding-remove">
                        <BackupTable
                            lstBackup={lstBackup}
                            restoreBackup={restoreBackup}
                            openSlider={openSlider}
                            backupId={backupId}
                        />
                    </div>
                </div>
            </div>
            {flgShowSlider ?
                <div className="slider1-60">
                    <BackupSlider
                        backupId={backupId}
                        backupObj={backupObj}
                        updateKey={updateKey}
                        closeSlider={closeSlider}
                    />
                </div>
                : null
            }
        </div>
    );
};

export default BackupCtrl;